// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1hQC8","title":"AfterBackImages_title__1Lmp_","images":"AfterBackImages_images__2bx5f"};